module.exports = __webpack_public_path__ + "media/images/writer/home/kv-bg-phone@2x-c5228b4c8aa0c8d007d33d482a7c9338.png";